export default __webpack_public_path__ + "static/media/eyes.36a7b2df.svg";